import { createTRPCClient, httpBatchStreamLink } from "@trpc/client";
import SuperJSON from "superjson";
import { type AppRouter } from "@youka/trpc-router/types";

export const getVanillaClient = (url: string, token?: string | null) => {
  let headers: Record<string, string> | undefined;
  if (token) {
    headers = {
      Authorization: `Bearer ${token}`,
    };
  }

  return createTRPCClient<AppRouter>({
    links: [
      httpBatchStreamLink({
        url,
        transformer: SuperJSON,
        headers,
      }),
    ],
  });
};
